import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  SimpleGrid,
  Text,
  useDisclosure,
  Flex,
  Badge,
  Box,
  Image,
} from "@chakra-ui/react";
import { Passagem } from "../../utils/interfaces";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";

export function ModalConexao() {
  const {isOpen, onOpen, onClose} = useDisclosure()
  const {watch} = useFormContext()

  const conexao = watch('conexao') as { isConnection: boolean, passagem: Passagem | null}

  useEffect(() => {
    if(conexao.isConnection){
      onOpen();
    }else {
      onClose()
    }
  }, [conexao, onOpen, onClose])

  if(!conexao.passagem){
    return (
      <></>
    )
  }

  return (
    <Modal
      size={"2xl"}
      isCentered
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onClose}
    >
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>
          <Text fontSize={'2xl'}>Viagem com conexão</Text>
          <Text>{conexao.passagem.origemLabel} até {conexao.passagem.destinoLabel}</Text>
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody
          pb={6}
          display={"flex"}
          flexDir={"column"}
          gap={4}
        >
          <Flex gap={2} direction={'column'}>
            {conexao.passagem.conexoes.map((conexao, index) => (
              <Flex direction={'column'}>
                <Box>
                  <Badge>{index + 1}º Embarque</Badge>
                </Box>
                <SimpleGrid columns={2}>
                  <Box>
                      <Flex gap={4}>
                      <Text>{conexao.origemLabel}</Text>
                      <Text>até</Text>
                      <Text>{conexao.destinoLabel}</Text>
                    </Flex>
                    <Text>Data de saída: {conexao.saidaDia} {conexao.saidaHora}</Text>
                    <Text>Data de chegada: {conexao.chegadaDia} {conexao.chegadaHora}</Text>
                    <Text>Código serviço: {conexao.servico}</Text>
                  </Box>
                  <Image src={conexao.viacao.logo} />
                </SimpleGrid>
              </Flex>
            ))}
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}
